/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */

import type {PropsWithChildren} from 'react';
import * as styles from '../styles/Screen.module.scss';

type ScreenProps<T extends React.ElementType> = PropsWithChildren & {
  /** The element to render this component as. */
  as?: T;
};

/**
 * Creates a top-level screen component with default styling. By default, this
 * renders a div. The element can be changed using the `as` prop.
 */
export const Screen = <T extends React.ElementType = 'div'>({
  as,
  className,
  ...props
}: ScreenProps<T> & Omit<React.ComponentProps<T>, keyof ScreenProps<T>>) => {
  const Component = as ?? 'div';
  return (
    <Component
      className={`${styles.container} ${className ?? ''}`}
      {...props}
    />
  );
};
